@for (option of tableHeaderItems(); track $index; let i = $index; let first = $first) {
  <th [class.small]="option.smallerSize"
      [class.work-ui-table-header--custom-first-column]="hasCustomFirstColumn() && first"
      class="work-ui-table-header"
      scope="col">
    <div (click)="option.sortable ? changeSortStatus(i) : null" [class.align-right]="option.alignRight"
         [class.sortable]="option.sortable"
         class="work-ui-table-header-content">
      @if (option.selectable) {
        <work-ui-checkbox (checkedChange)="checkboxChange.emit(tableHeaderItems()[i])"
                          [(ngModel)]="option.selectedStatus" [label]="option.label | translate"
                          [noMargin]="true" />
      } @else {
        <span class="work-text-no-wrap">
          {{ option.label | translate }}
        </span>
      }
      @if (option.sortable) {
        @if (option.sortStatus === 'NONE' || !sortOnClick) {
          <work-ui-icon name="swap_vert"
                        [fontSize]="16" />
        }
        @if (option.sortStatus === 'DESC' && sortOnClick) {
          <work-ui-icon
            class="sort-active"
            name="arrow_downward_alt"
            [fontSize]="16" />
        }
        @if (option.sortStatus === 'ASC' && sortOnClick) {
          <work-ui-icon
            class="sort-active"
            name="arrow_upward_alt"
            [fontSize]="16" />

        }
      }
    </div>
  </th>
}
